<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="grow py-2">
                <!-- <p>Selected Date: {{ selectedDate }}</p> -->
                <div class="flex flex-wrap -mx-3">
                    <!-- <div class="col-span-2 bg-blue-50/70 border border-blue-100 rounded p-5 text-center">
                        <p class="text-sm font-medium text-blue-950/70">Total Employee</p>
                        <p class="text-blue-500 text-5xl font-medium pt-5">65</p>
                    </div> -->
                    <div class="w-1/4 p-3">
                        <div class="bg-white pt-1 pb-5 rounded-lg shadow-[0_1px_7px_1px_rgba(0,0,0,0.05)]">
                            <div class="flex flex-wrap items-start px-5 py-4">
                                <div>
                                    <p class="text-[17px] leaidng-6 font-medium text-[#585858]">Total Employee</p>
                                    <p class="text-[#0086FF] text-4xl leading-normal font-semibold">{{ totalEmployee }}
                                    </p>
                                </div>
                                <img src="@/assets/blue-avatar.png" alt="blue avatar" class="ml-auto" />
                            </div>
                            <div class="flex divide-x divide-[#D6D6D6] px-2.5">
                                <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#0F990A] font-semibold pr-1">{{ activeEmployee }}</p>
                                    <p class="font-medium text-[#828282]">Active</p>
                                </div>
                                <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#E40C0C] font-semibold pr-1">{{ inactiveEmployee }}</p>
                                    <p class="font-medium text-[#828282]">InActive</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-1/4 p-3">
                        <div class="bg-white pt-1 pb-5 rounded-lg shadow-[0_1px_7px_1px_rgba(0,0,0,0.05)]">
                            <div class="flex flex-wrap items-start px-5 py-4">
                                <div>
                                    <p class="text-[17px] leaidng-6 font-medium text-[#585858]">Present</p>
                                    <p class="text-[#3FAB77] text-4xl leading-normal font-semibold">{{ present_days }}
                                    </p>
                                </div>
                                <img src="@/assets/green-avatar.png" alt="green avatar" class="ml-auto" />
                            </div>
                            <div class="flex divide-x divide-[#D6D6D6] px-2.5">
                                <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#0F990A] font-semibold pr-1">0</p>
                                    <p class="font-medium text-[#828282]">WFH</p>
                                </div>
                                <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#3FAB77] font-semibold pr-1">{{ present_days }}</p>
                                    <p class="font-medium text-[#828282]">At Office</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-1/4 p-3">
                        <div
                            class="h-full flex flex-wrap items-start bg-white px-5 py-4 rounded-lg shadow-[0_1px_7px_1px_rgba(0,0,0,0.05)]">
                            <div>
                                <p class="text-[17px] leaidng-6 font-medium text-[#585858]">Absent</p>
                                <p class="text-[#F06B30] text-4xl leading-normal font-semibold">{{ activeEmployee -
                                    present_days }}</p>
                            </div>
                            <img src="@/assets/red-avatar.png" alt="red avatar" class="ml-auto" />
                        </div>
                    </div>

                    <div class="w-1/4 p-3">
                        <div class="bg-white pt-1 pb-5 rounded-lg shadow-[0_1px_7px_1px_rgba(0,0,0,0.05)]">
                            <div class="flex flex-wrap items-start px-5 py-4">
                                <div>
                                    <p class="text-[17px] leaidng-6 font-medium text-[#585858]">On Leave</p>
                                    <p class="text-[#6351C3] text-4xl leading-normal font-semibold">{{ totalLeaveDays }}
                                    </p>
                                </div>
                                <img src="@/assets/purple-avatar.png" alt="purple avatar" class="ml-auto" />
                            </div>
                            <div class="flex divide-x divide-[#D6D6D6] px-2.5"
                                v-if="Object.keys(leaveTypeCount).length">
                                <div class="flex items-center text-sm leading-4 px-2.5"
                                    v-for="([leave_name, count], index) in Object.entries(leaveTypeCount)" :key="index">
                                    <p class="text-[#6351C3] font-semibold pr-1">{{ count }}</p>
                                    <p class="font-medium text-[#828282]">{{ leave_name }}</p>
                                </div>
                                <!-- <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#6351C3] font-semibold pr-1">10</p>
                                    <p class="font-medium text-[#828282]">Casual</p>
                                </div> -->
                            </div>
                            <div v-else class="flex divide-x divide-[#D6D6D6] px-2.5">
                                <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#6351C3] font-semibold pr-1">0</p>
                                    <p class="font-medium text-[#828282]">Medical</p>
                                </div>
                                <div class="flex items-center text-sm leading-4 px-2.5">
                                    <p class="text-[#6351C3] font-semibold pr-1">0</p>
                                    <p class="font-medium text-[#828282]">Casual</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- <div
                    class="flex w-fit divide-x py-3 divide-blue-300/50 bg-blue-200/30 border border-blue-300/30 mt-4 rounded-lg">
                    <div class="py-2 px-6">
                        <p class="text-xs text-center font-medium text-yellow-950/50">On leave</p>
                        <p class="text-center text-yellow-500/80 text-4xl font-medium pt-1">{{ totalLeaveDays }}</p>
                    </div> -->
                <!-- <div
                        v-for="(item, index) in leaveTypeCount"
                        :key="index"
                        class="py-2 px-6"
                        >
                        <p class="text-xs text-center font-medium text-yellow-950/50">
                            {{ item.leave_name }}
                        </p>
                        <p class="text-center text-yellow-500/80 text-xl font-medium pt-1">
                            {{ item.count }}
                        </p>
                        </div> -->
                <!-- <div v-for="([leave_name, count], index) in Object.entries(leaveTypeCount)" :key="index"
                        class="py-2 px-6">
                        <p class="text-xs text-center font-medium text-yellow-950/50">
                            {{ leave_name }}
                        </p>
                        <p class="text-center text-yellow-500/80 text-xl font-medium pt-1">
                            {{ count }}
                        </p>
                    </div>
                </div> -->

                <div class="mt-12">
                    <div class="flex items-center justify-between">
                        <h2 class="font-mediaum text-4xl text-black">Attendance Status</h2>
                        <button class="btn-primary-light flex items-center" @click="goToReport">
                            <span class="pr-2">Show More</span>
                            <i class="fas fa-chevron-right text-[10px]"></i>
                        </button>
                        <!-- <div class="flex items-center"> -->
                        <!-- <p class="text-sm">Status:</p>
                            <div class="w-28 ml-3">
                                <DropDown :options="attendanceStatus" :message="`Select Option`" v-model="selectedAttendance" />
                            </div> -->
                        <!-- <button class="ml-3 btn-primary-light flex items-center">
                                <span>
                                    <ArrowDownTrayIcon class="w-4 h-4"/>
                                </span>
                                <span class="pl-2">
                                    Download
                                </span>
                            </button> -->
                        <!-- </div> -->
                    </div>

                    <div class="glob_tablewpr rounded-lg mt-5">
                        <table class="glob_table">
                            <thead class="bg-[#ECF6FF]">
                                <tr>
                                    <th scope="col" class="text-base font-medium text-[#404A5A] px-6 py-4">
                                        Employer ID
                                    </th>
                                    <th scope="col" class="text-base font-medium text-[#404A5A] px-6 py-4">
                                        Employee Name
                                    </th>
                                    <th scope="col" class="text-base font-medium text-[#404A5A] px-6 py-4">
                                        Start
                                    </th>
                                    <th scope="col" class="text-base font-medium text-[#404A5A] px-6 py-4">
                                        End
                                    </th>
                                    <th scope="col" class="text-base font-medium text-[#404A5A] px-6 py-4">
                                        Hours Worked
                                    </th>
                                    <th scope="col" class="text-base font-medium text-[#404A5A] px-6 py-4">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="attendanceRecord.length">
                                <tr v-for="(item, index) in attendanceRecord" :key="index" class="bg-white border-b">
                                    <td scope="row" class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ item.user?.empid }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        <div class="flex items-center">
                                            <div>
                                                <span class="w-10 h-10 border rounded inline-block overflow-hidden">
                                                    <img class="w-full h-full object-cover rounded"
                                                        :src="item.user?.profile_image ? baseUrl + item.user?.profile_image : require('@/assets/user.png')"
                                                        @error="event => event.target.src = require('@/assets/user.png')"
                                                        alt="User Profile" />
                                                </span>
                                            </div>
                                            <div class="pl-3">
                                                <p class=" text-neutral-800 font-medium">{{ item.user?.fname }} {{
                                                    item.user?.lname }}</p>
                                                <p class="text-xs">{{ item.user?.designation }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ formatTime(item.check_in) }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ formatTime(item.check_out) }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        <div class="flex items-center" :class="['text-emerald-500']">
                                            <span class="pl-1"
                                                :class="getTimeColor(item.total_hours, fullDay, halfDay)">
                                                {{ item.total_hours }}
                                            </span>
                                        </div>

                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        <span
                                            class="border rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600">
                                            {{ item.status }}
                                        </span>
                                    </td>
                                </tr>
                                <!-- <tr v-if="attendanceRecord.length === 0">
                                    <td colspan="6" class="text-center py-4 text-gray-500">
                                        No attendance data found.
                                    </td>
                                </tr> -->
                            </tbody>
                            <tbody v-else>
                                <!-- <tr v-for="(attend, a) in attendances" :key="a">
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ attend.employerId }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        <div class="flex items-center space-x-2">
                                            <img :src="require(`@/assets/${attend.avatar}`)" />
                                            <span>{{ attend.name }}</span>
                                        </div>
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ attend.start }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ attend.end }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        {{ attend.hoursWorked }}
                                    </td>
                                    <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        <span :class="attend.status == 'In' ? 'text-[#0F990A]' : 'text-[#E40C0C]'">{{
                                            attend.status }}</span>
                                    </td>
                                </tr> -->
                                <tr>
                                    <td colspan="6" class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                        <p>No data available</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="mt-14">
                    <div class="flex items-center justify-between">
                        <h2 class="font-mediaum text-4xl text-black">Leaves</h2>
                        <button class="btn-primary-light flex items-center" @click="goToStatus">
                            <span class="pr-2">Show More</span>
                            <i class="fas fa-chevron-right text-[10px]"></i>
                        </button>
                    </div>
                    <div>
                        <div class="pt-4">
                            <TabGroup>
                                <TabList class="flex">
                                    <Tab v-for="items in leavesCategories" as="template" :key="items.id"
                                        v-slot="{ selected }">
                                        <button :class="['px-8 py-3.5 text-base font-medium leading-5 rounded-t-lg', 'focus:outline-none',
                                            selected
                                                ? 'text-[#3B82F6] bg-white shadow-[0_-2px_6px_1px_rgba(0,0,0,0.05)]'
                                                : 'text-[#767676] hover:text-[#3B82F6]',
                                        ]">
                                            {{ items.name }}
                                        </button>
                                    </Tab>
                                </TabList>
                                <div class="glob_tablewpr bg-white rounded-tl-none rounded-lg p-7">
                                    <TabPanels class="mt-2">
                                        <TabPanel v-for="items in leavesCategories" :key="items.id">
                                            <div v-if="items && items.data && items.data.length > 0">
                                                <table class="glob_table_two">
                                                    <thead class="bg-[#ECF6FF]">
                                                        <tr>
                                                            <th scope="col"
                                                                class="text-base font-medium text-[#404A5A] px-6 py-4">
                                                                Full Name</th>
                                                            <th scope="col"
                                                                class="text-base font-medium text-[#404A5A] px-6 py-4">
                                                                Apply</th>
                                                            <th scope="col"
                                                                class="text-base font-medium text-[#404A5A] px-6 py-4">
                                                                Type</th>
                                                            <th scope="col"
                                                                class="text-base font-medium text-[#404A5A] text-center px-6 py-4">
                                                                Days</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in items.data" :key="index">
                                                            <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                                                <div class="flex items-center">
                                                                    <div>
                                                                        <img class="w-8 h-8 object-cover rounded-full"
                                                                            :src="item.user.profile_image ? baseUrl + item.user.profile_image : require('@/assets/user.png')"
                                                                            @error="event => event.target.src = require('@/assets/user.png')"
                                                                            alt="User Profile" />
                                                                    </div>
                                                                    <div class="pl-3">
                                                                        <p
                                                                            class="tex-sm font-medium text-[#404A5A] truncate">
                                                                            {{ item.user.fname }} {{ item.user.lname }}
                                                                        </p>
                                                                        <p class="text- font-regular text-[#A2A2A2]">
                                                                            {{ item.user.designation }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td
                                                                class="text-sm font-regular text-[#404A5A] px-6 py-4 truncate">
                                                                {{ formatMainDate(item.applied_date) }}
                                                            </td>
                                                            <td class="text-sm font-regular text-[#404A5A] px-6 py-4">
                                                                {{ item.leave_name }}
                                                            </td>
                                                            <td
                                                                class="text-sm font-regular text-[#404A5A] text-center px-6 py-4">
                                                                {{ item.total_days }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else>
                                                <p>No data available</p>
                                            </div>
                                        </TabPanel>

                                    </TabPanels>
                                </div>
                            </TabGroup>
                        </div>
                    </div>

                    <!-- <div class="col-span-2 rounded-lg p-5 bg-neutral-50">
                            <div class="flex justify-between">
                                <p class="font-semibold text-xl text-neutral-800">Late Mark</p>
                                
                                <button class="inline-flex rounded border border-blue-100 bg-blue-50 p-2 text-sm text-blue-500 hover:bg-blue-500 hover:text-white focus:outline-none transition-all w-8 h-8">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                    </svg>
                                </button>
                            </div>

                            <div class="pt-3">
                                <div v-for="(item, index) in [1, 2, 3, 4, 5, 6]" :key="index" class="flex justify-between space-x-3 shadow-lg shadow-transparent hover:bg-white hover:shadow-lg hover:shadow-neutral-100 px-2 py-3 mt-1 rounded">
                                    <div class="">
                                        <div class="flex  items-center">
                                            <div class="h-10">
                                                <span class="w-10 h-10 border rounded inline-block">
                                                    <img class="w-full h-full object-cover rounded" src="@/assets/user.png" alt=""/>
                                                </span>
                                        
                                            </div>
                                            <div class="pl-2 w-28">
                                                <p class=" text-neutral-800 font-medium text-sm truncate">Kuntal Patra</p>
                                                <p class="text-xs text-neutral-400">Sr. Developer</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="">
                                        <p class="text-xs text-neutral-400">Check In</p>
                                        <p class="text-sm">10:45 am</p>
                                    </div>
                                    <div class="">
                                        <p class="text-xs text-neutral-400">Late</p>
                                        <p class="text-sm truncate">1hr 45min</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                </div>
            </div>
            <RightSideBar @data-to-parent="handleDataFromChild" />
        </section>
        <!-- <AdminSettingModal :items="this.percentageArray"/> -->
        <AdminSettingModal v-if="opensettingsmodal" :items="percentageArray" />
    </AdminLayout>
</template>
<script>
import { useDateStore } from '../../stores/useDateStore';
import AdminLayout from './AdminLayout.vue';
import AdminSettingModal from '../../components/AdminSettingModal.vue';
import moment from 'moment';
//import DropDown from '../../components/DropDown.vue';
import RightSideBar from '../../components/RightSideBar.vue';
//import DatePickerDate from '../../components/DatePickerDate.vue';
//import Datepicker from 'vue3-datepicker';
//import { ChevronDownIcon } from '@heroicons/vue/24/solid';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue';
import axios from "axios";
import { BASE_URL, BASE_URI, BASE_URL_POP } from "../../config";
import { createLocal } from 'the-storages';

const mirror = createLocal();
const storage = mirror._prx;

export default {
    name: 'AdminDashboard',
    components: {
        AdminLayout,
        AdminSettingModal,
        //DropDown,
        //DatePickerDate,
        // ChevronDownIcon,
        //ArrowDownTrayIcon,
        // ChevronRightIcon,
        TabGroup,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        RightSideBar,
        //Datepicker
    },
    data() {
        return {
            baseUrl: BASE_URL_POP + 'media/employeeProfile/',
            baseuri: BASE_URI,
            storage: storage,
            toDayDate: new Date(),
            shiftName: ['Morning Shift', 'Night Shift', 'Mid Shift ', 'Small Shift', 'Large Shift'],
            attendanceStatus: ['All', 'WFH', 'Leave', 'WFO'],
            selectedAttendance: 'All',
            selectedShift: 'Morning Shift',
            //selectedDate: new Date(),
            date: new Date(), // Default to current date
            leavesCategories: [
                {
                    id: 1,
                    name: 'Today Leaves',
                    data: []
                },
                {
                    id: 1,
                    name: 'Upcoming leaves',
                    data: []
                },
            ],
            EventCategories: [
                {
                    id: 1,
                    name: 'Birthday',
                    data: [
                        {
                            id: 1,
                            title: 'Does drinking coffee make you smarter?',
                            date: '5h ago',
                            commentCount: 5,
                            shareCount: 2,
                        },
                        {
                            id: 2,
                            title: "So you've bought coffee... now what?",
                            date: '2h ago',
                            commentCount: 3,
                            shareCount: 2,
                        },
                    ]
                },
                {
                    id: 1,
                    name: 'Work Anniversary',
                    data: [
                        {
                            id: 1,
                            title: 'Does drinking coffee make you smarter?',
                            date: '5h ago',
                            commentCount: 5,
                            shareCount: 2,
                        },
                        {
                            id: 2,
                            title: "So you've bought coffee... now what?",
                            date: '2h ago',
                            commentCount: 3,
                            shareCount: 2,
                        },
                    ]
                },
                {
                    id: 1,
                    name: 'Holiday',
                    data: [
                        {
                            id: 1,
                            title: 'Does drinking coffee make you smarter?',
                            date: '5h ago',
                            commentCount: 5,
                            shareCount: 2,
                        },
                        {
                            id: 2,
                            title: "So you've bought coffee... now what?",
                            date: '2h ago',
                            commentCount: 3,
                            shareCount: 2,
                        },
                    ]
                },
            ],
            companyName: '',
            opensettingsmodal: false,
            percentageArray: [],
            dataArray: [
                { id: 1, name: 'Item 1' },
                { id: 2, name: 'Item 2' },
                { id: 3, name: 'Item 3' },
                // Add more items as needed
            ],
            attendanceRecord: [],
            todayLeave: [],
            totalLeaveDays: 0,
            leaveTypeCount: [],
            present_days: 0,
            totalEmployee: 0,
            activeEmployee: 0,
            inactiveEmployee: 0,
            attendances: [
                {
                    employerId: 'RS-KOL-001',
                    name: 'Kathy Stewart',
                    avatar: 'kathy.png',
                    start: '09:43:36 AM',
                    end: '',
                    hoursWorked: '',
                    status: 'In'
                },
                {
                    employerId: 'RS-MUM-002',
                    name: 'Ronald Richards',
                    avatar: 'ronald.png',
                    start: '09:43:36 AM',
                    end: '09:00:59 PM',
                    hoursWorked: '11:17:23',
                    status: 'Out'
                },
                {
                    employerId: 'RS-NOI-003',
                    name: 'Dianne Russell',
                    avatar: 'dianne.png',
                    start: '09:43:36 AM',
                    end: '',
                    hoursWorked: '',
                    status: 'In'
                },
                {
                    employerId: 'RS-KOL-004',
                    name: 'John Doe',
                    avatar: 'john.png',
                    start: '09:42:48 AM',
                    end: '07:24:36 PM',
                    hoursWorked: '09:41:48',
                    status: 'Out'
                },
                {
                    employerId: 'RS-DEL-005',
                    name: 'Maria Brown',
                    avatar: 'maria.png',
                    start: '11:06:17 AM',
                    end: '08:22:10 PM',
                    hoursWorked: '09:15:49',
                    status: 'Out'
                }
            ],
            //isSelectedDate: false,
            fullDay: 0,
            halfDay: 0,
        }
    },

    created() {
        this.checkauthentication();
        //console.log("COMPANY DETAILS: ", this.storage.companyDetails);
        this.dateStore = useDateStore();
        //console.log("📅 Selected date in Dashboard:", this.dateStore.selectedDate);
        //this.companyName = this.storage.companyDetails.fname;
        this.companyName = this.storage.companyDetails.orgname;
        this.fetchAttendanceLeaveList();

          // ✅ Add this watch for dateStore.selectedDate
            this.$watch(
                () => this.dateStore.selectedDate,
                (newDate) => {
                    this.onDateChange(newDate);
                },
            );
    },
    methods:
    {
        goToReport() {
            window.location.href = `${this.baseuri}/attendance-report`;
        },
        goToStatus() {
            window.location.href = `${this.baseuri}/leave-status`;
        },

        formatTime(isoString) {
            if (!isoString) return "N/A";

            // If isoString is an object with $date, parse timestamp
            if (isoString.$date && isoString.$date.$numberLong) {
                const timestamp = isoString.$date.$numberLong;
                const date = new Date(parseInt(timestamp));
                return date.toLocaleTimeString("en-US", { hour12: false });
            }

            // Otherwise, assume isoString is a ISO8601 string
            const date = new Date(isoString);
            if (isNaN(date)) return "N/A"; // Invalid date check

            return date.toLocaleTimeString("en-US", { hour12: false });
        },



        formatMainDate(input) {
            if (!input) return "N/A";

            let dateString;

            if (typeof input === "string") {
                dateString = input;
            } else if (typeof input === "object" && input.$date) {
                dateString = input.$date;
            } else {
                return "N/A";
            }

            const date = new Date(dateString);
            if (isNaN(date)) return "N/A";

            return date.toLocaleDateString("en-US", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
        },



        formatDate(date) {
            //console.log("Selected date:", date);
            const d = new Date(date);
            const year = d.getFullYear();
            const month = ('0' + (d.getMonth() + 1)).slice(-2);
            const day = ('0' + d.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        },
        onDateChange(newDate) {
            this.date = newDate;
            //console.log("Date changed:", newDate);
            this.fetchAttendanceLeaveList(); // fetch fresh data whenever the date changes
        },
        async checkauthentication() {
            await axios.post(BASE_URL + '/checkAuthentication', { 'id': this.storage.companyDetails.id }, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.storage.token}`, } })
                .then((response) => {
                    if (response.data.status != 200) {
                        window.location.href = "/login";
                        localStorage.clear();

                    }

                })
        },

        handleDataFromChild(data) {
            // Access the data sent by the child component
            this.percentageArray = data;
            //console.log("child-data", this.percentageArray);
            // && data.attendance_Setting_percentage==100 && data.addemp_Setting_percentage ==100
            if (data.orgSettingPercentage == 100) {
                this.opensettingsmodal = false;
            } else {
                this.opensettingsmodal = true;
            }
        },

        async fetchAttendanceLeaveList() {
            try {
                const formatted = this.formatDate(this.date); // format the se
                const response = await axios.post(BASE_URL + '/get-admin-dashboard', {
                    date: formatted,
                    company_id: this.storage.companyDetails.id
                });
                this.leaveData = response.data;
                this.attendanceRecord = response.data.attendanceRecord;
                this.todayLeave = response.data.todayLeave;
                this.upcomingLeave = response.data.upcomingLeave;
                this.totalLeaveDays = response.data.totalLeaveDays;
                this.leaveTypeCount = response.data.leaveTypeCount;
                this.present_days = response.data.present_days;
                this.totalEmployee = response.data.totalEmployee;
                this.activeEmployee = response.data.activeEmployee;
                this.inactiveEmployee = response.data.inactiveEmployee;
                // Assigning the fetched data to the respective categories
                this.leavesCategories[0].data = response.data.todayLeave || []; // Use fallback empty array if undefined
                this.leavesCategories[1].data = response.data.upcomingLeave || []; // Use fallback empty array if undefined
                this.fullDay = response.data.full_day_hours;
                this.halfDay = response.data.half_day_hours;
                //console.log("Leave Data:", response.data);
            } catch (error) {
                console.error("Error fetching leave list:", error);
                //this.tostMessage('danger', 'Failed to fetch leave list');
            }
        },

        getTimeColor(timeStr, fullDay, halfDay) {
            const [hh, mm, ss] = timeStr.split(":").map(Number);
            const totalHours = hh + mm / 60 + ss / 3600;
            if (totalHours >= fullDay) {
                return 'text-green-600';
            } else if (totalHours >= halfDay) {
                return 'text-orange-600';
            } else {
                return 'text-red-600';
            }
        },




    },
    computed: {
        formattedDate() {
            const dateObject = new Date();
            return moment(dateObject).format('LLLL');
        },
        selectedDate() {
            return this.dateStore?.selectedDate;
        }
    },
    mounted() {
        //console.log("Mounted Admin Dashboard", localStorage.getItem("globalDateFormat"));
        // Make a GET request to the ipify API to retrieve the client's public IP address
        axios.get(BASE_URL + '/ip')
            .then(response => {
                // this.ipAddress = response.data.ip;
                // console.log("IP:",this.ipAddress);
                this.storage.set("ipAddress", response.data.ip);
            })
            .catch(error => {
                console.error('Error fetching IP address:', error);
            });
    },

    watch: {
        date(val) {
            if (val) {
                //this.isSelectedDate = true;
            }
        }
        
    }
}
</script>